import { Injectable } from '@angular/core';
import { AlertController, ToastController} from 'ionic-angular';


@Injectable()
export class AlertProvider {

  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController) {

  }

  toast(title: string, position: string): void {
    let toast = this.toastCtrl.create({ message: title, position: position, duration: 3000 });
    toast.present();
  }

  toastNotification(title: string): void {
    let toast = this.toastCtrl.create
      ({
            
            message: title,
            position: "top",
            duration: 3000,
            cssClass: "myToastNotification"
       });
    toast.present();
 
  }

  toastBlueCareHyundai(title: string, message:string): void {
    let toast = this.toastCtrl.create({
      message: message,
      position: "top",
      duration: 4000,
      cssClass: "myToastBlueCareHyundai"
    });
    toast.present();
  
    setTimeout(() => {
      const toastElement = document.querySelector('.myToastBlueCareHyundai');
      if (toastElement) {
        toastElement.innerHTML = `
        <div class="toast-overlay">
            <div class="toast-with-icon">
            <div class="icone">
              <img src="assets/icon/svg/alert-outline.svg" class="iconeToast" />
            </div>
            <div class="conteudo">
              <span class="titulo">${title}</span>
              <span class="mensagem">${message}</span>
            </div>
          </div>
          </div>
        `;
      }
    }, 100);
  }

  alert(title: string, message: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.alertCtrl.create({
        title: title,
        message: message,
        buttons:  [{
          text: 'OK',
          handler: () => {
            resolve();
          }
        }],
        enableBackdropDismiss: false
      }).present();
    });
  }

  async newAlert(tipoAlerta: string = 'info', message: string, title:string = null,toastMsg: string = '', buttons: Array<any>=[]): Promise<any> {
    return new Promise<any>((resolve, reject) => {

      let cssAlert=''
      if(tipoAlerta == 'erro'){
        title = title || "Atenção!";
        cssAlert = "alertErro";
      } else if(tipoAlerta == 'aviso'){
          title = title || "Atenção!";
          cssAlert = "alertAviso";
      } else if(tipoAlerta == 'info'){
          title = title || "Lembrete:";
          cssAlert = "alertInfo";
      } else if(tipoAlerta == 'sucesso'){
          title = title || "Tudo certo!";
          cssAlert = "alertSucesso";
      } else if(tipoAlerta == 'generico'){
          title= title || "Atenção!";
      }
      

      if(!buttons.length){
        buttons =  [{
          text: 'OK',
          handler: () => {
            resolve(true);
          }
        }];
      } else {
        buttons = buttons.map(b => ({
          ...b,
          handler: () => {
            let result = true;

            if (b.handler) {
              let retorno = b.handler();
              if (retorno !== undefined) {
                result = retorno;
              }
            }

            resolve(result);
          }
        }));
      }

      

      this.alertCtrl.create({
        title: title,
        message: message,
        buttons:  buttons,
        enableBackdropDismiss: false,
        cssClass: cssAlert
      }).present();

      if(toastMsg != ''){
        const toast = this.toastCtrl.create({
          message: toastMsg,
          duration: 5000,
          position: 'bottom',
          showCloseButton: true,
          closeButtonText: "X",
          cssClass: 'alert-toast-'+tipoAlerta
        });
        toast.present();
      }
      

    });
  }

  // alertSelect(title: string, options: any, callback:any):void{
  //   this.alertCtrl.create({
  //     title: title,
  //     message: `<img src="https:////upload.wikimedia.org/wikipedia/commons/thumb/0/05/Flag_of_Brazil.svg/22px-Flag_of_Brazil.svg.png">`,
  //     inputs: options,
  //     buttons: [{text: 'Ok', handler: (data)=>{callback(data);}}],
  //   }).present();
  // }
 
  alertCallback(title: string, message: string, callback:any): void {
    this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [{text: 'Ok', handler: ()=>{callback();}}],
      enableBackdropDismiss: false
    }).present();
  }

  confirm(title: string, message: string, callback: any, cancel:any = console.log('Confirm:Say:No')): void {
    this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        { text: "Não", role: 'Cancel', handler: () => { cancel();  } },
        {
          text: "Sim",
          handler: () => {
            callback();
          }
        }
      ]
    })
      .present()
  }

  presentPrompt(title:string, cancel: any, confirm: any, placeholder:any = 'Descreva') {
    let alert = this.alertCtrl.create({
      title: title,
      inputs: [
        {
          name: 'obs',
          placeholder: placeholder,
          type: 'textarea'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: cancel,
        },
        {
          text: 'Salvar',
          handler:data => {
            if (data.obs) {
              confirm(data.obs);
            } else {
              // invalid login
              return false;
            }
          }
        }
      ]
    });
    alert.present();
  }

  presentPromptNumber(title:string, cancel: any, confirm: any, placeholder:any = 'Descreva') {
    let alert = this.alertCtrl.create({
      title: title,
      inputs: [
        {
          name: 'obs',
          placeholder: placeholder,
          type: 'number'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: cancel,
        },
        {
          text: 'Salvar',
          handler:data => {
            if (data.obs) {
              confirm(data.obs);
            } else {
              // invalid login
              return false;
            }
          }
        }
      ]
    });
    alert.present();
  }


  presentPromptOQueTrocar(title:string, confirm: any, oqTrocar:string, pqTrocar:string, placeholder:any = 'Descreva') {
    let alert = this.alertCtrl.create({
      title: title,
      message: "Preencha o que trocar e por quê trocar!",
      inputs: [
        {
          name: 'oQueTrocar',
          placeholder: "O que trocar?",
          type: 'textarea',
          value: oqTrocar
        },
        {
          name: 'pqTrocar',
          placeholder: "Por que trocar?",
          type: 'textarea',
          value: pqTrocar
        }
      ],
      buttons: [
        {
          text: 'Salvar',
          handler:data => {
            if (data.oQueTrocar && data.pqTrocar) {
              confirm(data.oQueTrocar, data.pqTrocar);
            } else {
              // invalid login
              return false;
            }
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  presentPromptPassword(title:string, cancel: any, confirm: any) {
    let alert = this.alertCtrl.create({
      title: title,
      inputs: [
        {
          name: 'password',
          placeholder: 'Digite a senha',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: cancel,
        },
        {
          text: 'Salvar',
          handler:data => {
            if (data.password) {
              confirm(data.password);
            } else {
              // invalid login
              return false;
            }
          }
        }
      ]
    });
    alert.present();
  }

  alertOptions(title: string, message: string, textTrue: string, TextFalse: string, callbackTrue: any, callbackFalse: any): void {
    this.alertCtrl.create({
      title: title,
      message: message,
      buttons: [
        { text: TextFalse,
          handler: () => {
            callbackFalse();
          }
        },
        {
          text: textTrue,
          handler: () => {
            callbackTrue();
          }
        }
      ]
    })
      .present()
  }
}



// WEBPACK FOOTER //
// ./src/providers/alert/alert.ts